import { WorkspaceLogo as WorkspaceLogoIcon } from 'components/Icons/WorkspaceLogo'
import { cva, cx } from 'styled-system/css'
import { Square, SquareProps } from 'styled-system/jsx'
import { Icon } from 'ui-kit/icon'

const workspaceLogoRecipe = cva({
  base: {
    width: 'full',
    height: 'full',
    color: 'fg.default',
    overflow: 'hidden',
    borderRadius: 'l2',
  },
  variants: {
    variant: {
      default: {
        backgroundColor: 'bg.default',
      },
      text: {
        backgroundColor: 'bg.subtle',
        textAlign: 'center',
        textTransform: 'uppercase',
      },
    },
  },
})
const workspaceLogoIconRecipe = cva({
  base: {
    maxWidth: 'full',
    maxHeight: 'full',
    objectFit: 'contain',
    '& text': {
      fontFamily: 'var(--global-font-body)',
    },
  },
})

export function WorkspaceLogo({
  logoUri,
  workspaceName,
  className,
  ...props
}: {
  logoUri?: string
  workspaceName?: string
} & SquareProps) {
  const classnames = workspaceLogoRecipe({
    variant: !!workspaceName ? 'text' : 'default',
  })
  return (
    <Square className={cx(classnames, className)} {...props}>
      <Logo logoUri={logoUri} workspaceName={workspaceName} />
    </Square>
  )
}

function Logo({
  logoUri,
  workspaceName,
}: {
  logoUri?: string
  workspaceName?: string
}) {
  const classname = workspaceLogoIconRecipe()
  if (logoUri) {
    return <img src={logoUri} alt={'Workspace Logo'} className={classname} />
  }

  if (workspaceName) {
    return (
      <svg
        viewBox='0 0 32 32'
        preserveAspectRatio='xMinYMid meet'
        xmlns='http://www.w3.org/2000/svg'
        className={classname}
      >
        <text
          x='50%'
          y='55%'
          dominantBaseline='middle'
          textAnchor='middle'
          fontSize='20'
          fill='currentColor'
        >
          {workspaceName[0]}
        </text>
      </svg>
    )
  }

  return (
    <Icon>
      <WorkspaceLogoIcon className={classname} />
    </Icon>
  )
}
